type SimpleMenuItemShape<
  T extends Record<string, unknown> = Record<string, unknown>
> = T & {
  menuItems?: SimpleMenuItemShape<T>[];
};

export function flattenMenuItems<T extends SimpleMenuItemShape>(
  menuItems: T[]
) {
  return menuItems.flatMap((item) => {
    if (item.menuItems) {
      const childMenuItems = flattenMenuItems(item.menuItems);
      return [item, ...childMenuItems];
    } else {
      return [item];
    }
  });
}

// returns list of items parents, including parentId, granparentId etc.
export function getMenuItemsParentIds<
  T extends SimpleMenuItemShape<{ id: string }>
>(menuItemId: string, flatMenuItemShapes: T[], acc: string[] = []) {
  const parent = flatMenuItemShapes.find((it) =>
    it.menuItems?.some((item) => item.id === menuItemId)
  );
  if (parent) {
    return getMenuItemsParentIds(parent.id, flatMenuItemShapes, [
      ...acc,
      parent.id,
    ]);
  } else {
    return acc;
  }
}

// Copy and add 'id' and 'isOpen' to all items recursively
export function addInternalMenuItemsProperties<T extends SimpleMenuItemShape>(
  menuItems: T[] = [],
  openMenuItems: string[],
  parentId?: string
) {
  return menuItems.map((child, index) => {
    const id = [parentId, `${index}`].filter(Boolean).join('_');
    if (!child.menuItems) {
      return {
        ...child,
        id,
      };
    }
    return {
      ...child,
      id,
      isOpen: openMenuItems.includes(id),
      menuItems: addInternalMenuItemsProperties(
        child.menuItems,
        openMenuItems,
        id
      ),
    };
  });
}
